import React from "react";
import StatusBadge from "./StatusBadge";
import { formatDateTime, formatScenarioKind } from "../utils/formatters";

export default function ScenarioToolbar({
  activeScenario,
  scenarios,
  periods,
  isOutdated,
  onSelectScenario,
  onCreateScenario,
  onDuplicateScenario,
  onRenameScenario,
  onDeleteScenario,
  onToggleScenarioKind,
  onChangePeriod,
  onRunSimulation,
}) {
  if (!activeScenario) {
    return <section className="swb-panel">Nenhum cenário selecionado.</section>;
  }

  const handleCreate = () => {
    const name = window.prompt("Nome do novo cenário:", `Novo cenário`);
    if (name == null) return;
    onCreateScenario(name);
  };

  const handleRename = () => {
    const nextName = window.prompt("Novo nome do cenário:", activeScenario.name);
    if (nextName == null) return;
    const ok = onRenameScenario(activeScenario.id, nextName);
    if (!ok) window.alert("Informe um nome válido.");
  };

  const handleDelete = () => {
    const confirmed = window.confirm(
      `Excluir o cenário "${activeScenario.name}"? Esta ação remove apenas o mock local.`
    );
    if (!confirmed) return;
    const result = onDeleteScenario(activeScenario.id);
    if (!result?.ok && result?.reason) window.alert(result.reason);
  };

  return (
    <section className="swb-panel swb-toolbar">
      <div className="swb-toolbar__main">
        <div className="swb-toolbar__block">
          <label className="swb-field">
            <span>Cenário ativo</span>
            <select
              value={activeScenario.id}
              onChange={(e) => onSelectScenario(e.target.value)}
            >
              {(scenarios || []).map((scenario) => (
                <option key={scenario.id} value={scenario.id}>
                  {scenario.name}
                </option>
              ))}
            </select>
          </label>

          <label className="swb-field swb-field--sm">
            <span>Período</span>
            <select
              value={activeScenario.period}
              onChange={(e) => onChangePeriod(e.target.value)}
            >
              {(periods || []).map((period) => (
                <option key={period} value={period}>
                  {period}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div className="swb-toolbar__meta">
          <div className="swb-toolbar__meta-row">
            <StatusBadge status={formatScenarioKind(activeScenario.kind)} />
            <span className={`swb-sync-flag ${isOutdated ? "is-outdated" : "is-ok"}`}>
              {isOutdated ? "Simulação desatualizada" : "Simulação atualizada"}
            </span>
          </div>
          <div className="swb-toolbar__meta-row">
            <span>Última execução: {formatDateTime(activeScenario.lastRun?.ranAt)}</span>
          </div>
        </div>
      </div>

      <div className="swb-toolbar__actions">
        <button type="button" className="swb-btn" onClick={handleCreate}>
          Novo cenário
        </button>
        <button
          type="button"
          className="swb-btn"
          onClick={() => onDuplicateScenario(activeScenario.id)}
        >
          Duplicar
        </button>
        <button type="button" className="swb-btn" onClick={handleRename}>
          Renomear
        </button>
        <button type="button" className="swb-btn swb-btn--danger" onClick={handleDelete}>
          Excluir
        </button>
        <button
          type="button"
          className="swb-btn"
          onClick={() =>
            onToggleScenarioKind(activeScenario.id, activeScenario.kind === "official" ? "draft" : "official")
          }
        >
          Marcar como {activeScenario.kind === "official" ? "rascunho" : "oficial"}
        </button>
        <button type="button" className="swb-btn swb-btn--primary" onClick={onRunSimulation}>
          Rodar simulação
        </button>
      </div>
    </section>
  );
}
